import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import { actionLoadData } from './actions';
import App from './components/app';
import rootReducer from './reducers';

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

if (module.hot) {
  module.hot.accept('./reducers', () => {
    const nextRoootReducer = require('./reducers/').default; // eslint-disable-line global-require
    store.replaceReducer(nextRoootReducer);
  });
}

// Data from global variable if available
// Else - Error (TODO)
if (window.appJs) {
  store.dispatch(actionLoadData(window.appJs));
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('bundle-tool')
);



// WEBPACK FOOTER //
// ./app/main.js